// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__froLS","text":"style_text__nBrCX","actions":"style_actions__+Ol4I","actions_btn":"style_actions_btn__nth3p"};